import { tv } from 'tailwind-variants';

export const customButtonVariant = tv({
  compoundVariants: [
    {
      className: 'active:!bg-red-400',
      color: 'red',
      variant: 'contained',
    },
    {
      className: 'active:!bg-green-600',
      color: 'green',
      variant: 'contained',
    },
    {
      className: 'active:!bg-[#8AD4C5]',
      color: 'green-2',
      variant: 'contained',
    },
    {
      className: 'active:!bg-[#AFEEE3]',
      color: 'green-3',
      variant: 'contained',
    },
    {
      className: 'active:!bg-[#4b94ff]',
      color: 'blue',
      variant: 'contained',
    },
    {
      className: 'active:!bg-[#b1d0ff]',
      color: 'blue-2',
      variant: 'contained',
    },
    {
      className: 'active:!bg-red-50',
      color: 'red',
      variant: 'outlined',
    },
    {
      className: 'active:!bg-[#f2f2f2]',
      color: 'gray',
      variant: 'outlined',
    },
    {
      className: 'active:!bg-turquoise-100',
      color: 'green',
      variant: 'outlined',
    },
    {
      className: 'active:!bg-[#E6F7F3]',
      color: 'green-2',
      variant: 'outlined',
    },
    {
      className: 'active:!bg-[#eaf2ff]',
      color: 'blue',
      variant: 'outlined',
    },
  ],
  defaultVariants: {
    color: 'red',
    variant: 'contained',
  },
  variants: {
    color: {
      'blue': '',
      'blue-2': '',
      'gray': '',
      'green': '',
      'green-2': '',
      'green-3': '',
      'red': '',
    },
    variant: {
      contained: '',
      outlined: '',
    },
  },
});
